module.exports = __webpack_public_path__ + "static/media/second-fold.ae74261d.svg";